import React, { useEffect } from 'react';
import { ICellRendererParams } from 'ag-grid-community';
import AgileUploadRow from '@components/agile/types/AgileUploadRow';
import { ERROR_COLOR } from 'src/constants/values';
import Icon from '@amzn/meridian/icon';
import trashTokens from '@amzn/meridian-tokens/base/icon/trash';
import Button from '@amzn/meridian/button';

const AtBulkUploadDeleteButtonCellRenderer = (params: {
  node: ICellRendererParams;
  setRowData: (value: AgileUploadRow[]) => void;
  rowData: AgileUploadRow[];
  setDisableAdjustCapacityButton: (value: boolean) => void;
  setRecommendationFlag: (value: boolean) => void;
}) => {
  const { node, setRowData, rowData, setDisableAdjustCapacityButton, setRecommendationFlag } = params;

  const disableRecomendationButton = () => {
    const listOfCapacity = rowData.map((obj) => obj.fohCapacity.capacity);
    const listOfsubcategoryId = rowData.map((obj) => obj.subcategoryId);
    const listOfMacroplanogramIds = rowData.map((obj) => obj.macroplanogramId);
    return (
      listOfCapacity.includes(null) ||
      listOfCapacity.includes(0) ||
      listOfsubcategoryId.includes(undefined) ||
      listOfsubcategoryId.includes('') ||
      listOfMacroplanogramIds.includes(undefined) ||
      listOfMacroplanogramIds.includes('')
    );
  };

  useEffect(() => {
    setDisableAdjustCapacityButton(disableRecomendationButton());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [rowData]);
  const onClick = () => {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    const result = rowData.filter((row) => row.index !== node.data.index);
    if (result.length === 0) {
      setRowData([]);
      setDisableAdjustCapacityButton(true);
    } else {
      setRowData(result);
    }
    setRecommendationFlag(false);
  };
  return (
    <Button className={ERROR_COLOR} type="icon" onClick={onClick}>
      <Icon tokens={trashTokens} />
    </Button>
  );
};
export default AtBulkUploadDeleteButtonCellRenderer;
